var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoominfoScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea576c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45287,
    stopColor: "#ea1f1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ea1b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#811b46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.73456,69.04071v-11.00256c0-.38464-.30994-.6947-.6944-.6947h-3.5448c-.38446,0-.6944.31-.6944.6947v6.76361h-14.10663c-.38428,0-.6944.31-.6944.69452v3.54443c0,.38464.31012.6947.6944.6947h18.34583c.38446,0,.6944-.31.6944-.6947Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.73456,30.96094c0-.38464-.30994-.69464-.6944-.69464h-4.2392l-6.70605.01239c-.38446,0-.6944.30988-.6944.69452v3.53198c0,.38464.30994.69464.6944.69464h3.25635l-31.08582,29.60187v4.23895c0,.3847.31.69464.6944.69464h13.41211c.3844,0,.6944-.31006.6944-.69464v-3.54443c0-.38452-.31-.69452-.6944-.69452h-6.99518l27.42419-26.0943v3.19843c0,.38452.30994.69452.6944.69452h3.55725c.38434-.01233.68195-.32239.68195-.70697v-10.93243Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.51715,42.59863c.38428,0,.68195-.31.68195-.69452v-6.70593l4.93359.00171,11.63977-.01398c.38434,0,.6944-.31.6944-.6947v-3.53198c0-.38458-.31006-.69464-.68207-.69464h-20.80017c-.3844,0-.6944.31-.6944.69464v10.94489c0,.38458.31.69452.6944.69452h3.53253Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoominfoScraper);
export default __webpack_public_path__ + "static/media/zoominfo-scraper.92286acda7ae1d26c10fb4a7cc12054d.svg";
export { ForwardRef as ReactComponent };